export const getType = clientData => (clientData == null ? void 0 : clientData.type) ?? null;
//# sourceMappingURL=get-type.js.map